import { render, staticRenderFns } from "./CardUsuario.vue?vue&type=template&id=cdfe6b9a&scoped=true&"
import script from "./CardUsuario.vue?vue&type=script&lang=js&"
export * from "./CardUsuario.vue?vue&type=script&lang=js&"
import style0 from "./CardUsuario.vue?vue&type=style&index=0&id=cdfe6b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfe6b9a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdfe6b9a')) {
      api.createRecord('cdfe6b9a', component.options)
    } else {
      api.reload('cdfe6b9a', component.options)
    }
    module.hot.accept("./CardUsuario.vue?vue&type=template&id=cdfe6b9a&scoped=true&", function () {
      api.rerender('cdfe6b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Perfil/components/CardUsuario.vue"
export default component.exports